module.exports = __webpack_public_path__ + "img/kx7.341a7f53.png";